import { render, staticRenderFns } from "./BlockedCommodityChart.vue?vue&type=template&id=371b8644&scoped=true"
import script from "./BlockedCommodityChart.vue?vue&type=script&lang=ts"
export * from "./BlockedCommodityChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b8644",
  null
  
)

export default component.exports